import TextField from "@material-ui/core/TextField"

const NumberTextField = props => {
    return (
        <TextField
            {...props}
            onKeyPress={event => {
                if (!/[0-9]/.test(event.key)) {
                    event.preventDefault()
                }
            }}
        />
    )
}

export default NumberTextField
